<script setup>
import { ref,inject,onMounted,provide  } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios';
import { useMemberStore } from '../../stores';
const userStore = useMemberStore();
const baseURL = 'https://devmini.walkertour.cn';
const rootPath = "/www/wwwroot/testMiniServer/server/dist";
const EnumStandardCarGroup = {
	77:'豪7',
	80:'舒11',
	81:'舒9',
	82:'舒5',
	83:'经9',
	84:'经7',
	85:'经5'
}
const EnumCustomerAmenity = {
	1:'举牌服务',
	2:'儿童座椅'
}
const billid = inject('billid');
const forbidEdit = ref(false);
const size = ref('default')
const labelPosition = ref('right')
const imageUrl = ref('')
const headers = ref({
	'Authorization': `${userStore.profile?.token}`,
})

const sizeForm = ref({
	
});
const cxOptions = ref([])
onMounted(async()=>{
	if(billid.value!=null&&billid.value!=''){
		const response = await axios.post('/orders/info/queryMiniDetail', {
		  billid:billid.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			sizeForm.value = response.data.data;
		}
	}
})
function onSubmit() {
  console.log('submit!')
}
const handleAvatarSuccess= (
  response,
  uploadFile
) => {
  if(response.status===0){
  	imageUrl.value = response.imgUrl.replace(rootPath,baseURL);
  	sizeForm.value.cover_image = response.imgUrl;
  }
}

const beforeAvatarUpload = (rawFile) => {
  if (rawFile.type !== 'image/jpeg'&&rawFile.type !== 'image/png') {
    ElMessage.error('Avatar picture must be JPG/PNG format!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('Avatar picture size can not exceed 2MB!')
    return false
  }
  return true
}
</script>
<template>
	<el-form
	    ref="form"
	    :model="sizeForm"
	    label-width="auto"
	    :label-position="labelPosition"
	    :size="size"
		style="height: 500px;overflow-y: scroll;"
	  >
		<div style="display: flex;">
			<el-form-item label="订单号" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.order_id}}</el-text>
			</el-form-item>
			<el-form-item label="订单状态" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.status}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="支付金额" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.zfje}}</el-text>
			</el-form-item>
			<el-form-item label="优惠券" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.coupon}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="积分" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.integral}}</el-text>
			</el-form-item>
			<el-form-item label="支付状态" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.zfzt}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="备注" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.memo?.memo}}</el-text>
			</el-form-item>
		</div>
		<h4>
			乘客
		</h4>
		<div style="display: flex;">
			<el-form-item label="姓名" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.xm}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="手机号" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.mobile}}</el-text>
			</el-form-item>
			<el-form-item label="邮箱" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.email}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="人数" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.customer_rs}}</el-text>
			</el-form-item>
			<el-form-item label="行李" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.customer_bag}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="特殊要求" style="width: 98%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.passenger?.spdesc}}</el-text>
			</el-form-item>
		</div>
		<h4>
			行程信息
		</h4>
		<div style="display: flex;">
			<el-form-item label="出发地" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.trip?.cfd}}</el-text>
			</el-form-item>
			<el-form-item label="目的地" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.trip?.mdd}}</el-text>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="航班号" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.trip?.hbh}}</el-text>
			</el-form-item>
			<el-form-item label="机场" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.trip?.jc}}</el-text>
			</el-form-item>
		</div>
		<h4>
			订购产品
		</h4>
		<div style="display: flex;">
			<el-form-item label="编号" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?sizeForm.product.out_id:''}}</el-text>
			</el-form-item>
			<el-form-item label="名称" style="width: 48%;">
			  <el-text class="mx-1" type="primary">{{sizeForm.product?sizeForm.product.mc:''}}</el-text>
			</el-form-item>
		</div>
	  </el-form>
</template>

<style scoped>
	.avatar-uploader .avatar {
	  width: 90px;
	  height: 90px;
	  display: block;
	}
	.avatar-uploader .el-upload {
	  border: 1px dashed var(--el-border-color);
	  border-radius: 6px;
	  cursor: pointer;
	  position: relative;
	  overflow: hidden;
	  transition: var(--el-transition-duration-fast);
	}
	
	.avatar-uploader .el-upload:hover {
	  border-color: var(--el-color-primary);
	}
	
	.el-icon.avatar-uploader-icon {
	  font-size: 28px;
	  color: #8c939d;
	  width: 90px;
	  height: 90px;
	  text-align: center;
	}
</style>